import { configureStore } from '@reduxjs/toolkit';
import designSlice from './slices/designSlice';
import userSlice from './slices/userSlice'; 
import productsSlice from './slices/productsSlice';
import userCookieMiddleware from './middleware/userCookieMiddleware';
import offerSlice from './slices/offerSlice';

export const store = configureStore({
  reducer: {
    design: designSlice,
    user: userSlice,
    products: productsSlice,
    offer: offerSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(userCookieMiddleware),
});